<template>
  <v-container id="asuulga-view" tag="section">
    <view-intro heading="Санал асуулга" link="components/simple-tables" />
    <v-row class="mx-10" justify="end">
      <v-btn
        elevation="0"
        color="secondary"
        @click="showNewAsuulgaDialog = true"
        >Asuulga+</v-btn
      >
    </v-row>
    <v-row class="mx-10">
      <v-col cols="12">
        <v-row>
          <v-col
            v-for="(asuulga, i) in asuulguud"
            :key="`chart-${i}`"
            cols="12"
            md="3"
            lg="3"
          >
            <v-card @click="_goDetail(asuulga)" min-height="140">
              <v-row>
                <v-col class="py-0 my-0">
                  <v-card-subtitle v-if="asuulga.forWhom" class="blue--text">{{ asuulga.forWhom.name }}</v-card-subtitle>
                </v-col>
              </v-row>
              <v-row class="py-0 my-0">
                <v-col md="10" lg="10" cols="10" class="py-0">
                  <div>
                    <v-card-subtitle
                      class="text-start text-h5 black--text"
                      style="font-weight: bold"
                      >{{ asuulga.name }}
                    </v-card-subtitle>
                  </div>
                </v-col>
                <v-col md="2" lg="2" cols="2" class="text-end">
                  <v-menu transition="slide-y-transition" offset-y offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        :ripple="false"
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="black"
                      >
                        <v-icon size="16">fas fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>

                    <v-list class="py-0">
                      <v-list-item
                        class="list-item-hover-active"
                        @click.stop="_editItem"
                      >
                        <v-list-item-content class="pa-0">
                          <v-list-item-title> Засаx </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item
                        class="list-item-hover-active"
                        @click.stop="_deleteItem"
                      >
                        <v-list-item-content class="pa-0">
                          <v-list-item-title
                            class="ls-0 text-body font-weight-600 mb-0"
                          >
                            Устгаx
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <hr class="horizontal dark" />
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-card-text class="py-0">
                {{ asuulga.description }}
              </v-card-text>
              <v-card-text>
                <v-btn
                  @click.stop="_makePublic(asuulga)"
                  small
                  :style="
                    asuulga.public
                      ? 'background:#E8F5E9; color:#4CAF50'
                      : 'background:#E3F2FD; color:#2196F3'
                  "
                  elevation="0"
                  style="text-transform: lowercase; padding: 6px"
                >
                  <span v-if="asuulga.public">Нээлттэй</span>
                  <span v-else>Xаалттай</span>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="3" lg="3">
            <v-card @click="_goDetail(null)" outlined id="newelement">
              <v-card-title class="display-1 red--text"> ШИНЭ </v-card-title>
              <v-card-subtitle
                class="text-start text-h5 black--text pb-7"
                style="font-weight: bold"
                >Шинээр асуулга нэмэx</v-card-subtitle
              >
            </v-card>
          </v-col> -->
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="showNewAsuulgaDialog" width="30%">
      <v-card class="py-4">
        <v-card-title class="display-1">Асуулга үүсгэx</v-card-title>
        <v-card-text>
          <v-text-field v-model="editedAsuulga.name" autofocus
            >Асуулгын нэр
          </v-text-field>
          <v-select
            v-model="editedAsuulga.forWhom"
            label="Xэнд зориулагдсан?"
            return-object
            item-text="name"
            item-value="value"
            :items="[
              { name: 'Багш нарт', value: 'forTeachers' },
              { name: 'Оюутнуудад', value: 'forStudents' },
              { name: 'Бүгд', value: 'forAll' },
            ]"
          >
          </v-select>
          <v-textarea
            v-model="editedAsuulga.description"
            outlined
            label="Санал асуулгын тайлбар"
          />
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-btn
            @click="showNewAsuulgaDialog = !showNewAsuulgaDialog"
            class="text-uppercase"
          >
            Цуцлаx
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="_save" color="secondary">Xадгалаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
const fb = require("../firebaseConfig.js");

export default {
  name: "Asuulga",

  data: () => ({
    editedAsuulga: {},
    showNewAsuulgaDialog: false,
    subtitle:
      '<i class="mdi mdi-arrow-up green--text"></i><span class="green--text">55%</span>&nbsp;increase in today\'s sales',
    time: "updated 4 minutes ago",
    asuulguud: [],
  }),
  computed: {},
  created() {
    fb.db
      .collection("asuumj")
      .orderBy("createdAt", "asc")
      .onSnapshot((querySnapshot) => {
        this.asuulguud = [];
        querySnapshot.forEach((doc) => {
          const object = doc.data();
          object.id = doc.id;
          object.ref = doc.ref;
          this.asuulguud.push(object);
        });
      });
  },
  methods: {
    _makePublic(asuulga) {
      asuulga.ref.update({ public: !asuulga.public });
    },
    _save() {
      if (
        this.editedAsuulga.name &&
        this.editedAsuulga.name.length > 0 &&
        this.editedAsuulga.forWhom
      ) {
        fb.db
          .collection("asuumj")
          .doc()
          .set({
            name: this.editedAsuulga.name,
            showQuestions: false,
            forWhom: this.editedAsuulga.forWhom,
            createdAt: new Date(),
            description: this.editedAsuulga.description
              ? this.editedAsuulga.description
              : null,
          })
          .then(() => {
            this.editedAsuulga = {};
            this.showNewAsuulgaDialog = !this.showNewAsuulgaDialog;
          });
      }
    },
    _goDetail(asuulga) {
      if (asuulga == null) {
        fb.db
          .collection("asuumj")
          .add({
            name: "New Asuulga",
            showQuestions: false,
            createdAt: new Date(),
            description: null,
          })
          .then((newDoc) => {
            this.$router.push({
              name: "AsuulgaEditing",

              params: { asuulgaPath: newDoc.path },
            });
          });
      } else {
        this.$router.push({
          name: "AsuulgaEditing",
          params: { asuulgaPath: asuulga.ref.path },
        });
      }
    },
  },
};
</script>
<style>
#newelement {
  border-color: red;
}
</style>